import { FieldControllerTypes } from '../../../components/form_v2/types';
import { CommunicationTypes } from '../../static_values';

export const createNoteFields = [
  {
    control: FieldControllerTypes.date,
    name: 'date_note',
    label: 'Ημερομηνία',
    required: true,
    customLabel: true,
  },
  {
    control: FieldControllerTypes.textarea,
    type: 'search',
    name: 'note',
    label: 'Σημείωση',
    required: true,
  },
];

export const getNoteFields = [
  [{
    control: FieldControllerTypes.date,
    name: 'date_note_from',
    label: 'Από',
  },
  {
    control: FieldControllerTypes.date,
    name: 'date_note_to',
    label: 'Έως',
  }]
];

export const createCommunicationFields = [
  [{
    control: FieldControllerTypes.input,
    name: 'subject',
    label: 'Θέμα',
    type: 'search',
    required: true
  }],
  [{
    control: FieldControllerTypes.date,
    name: 'date',
    label: 'Ημερομηνία',
    customLabel: true,
    required: true
  },
  {
    control: FieldControllerTypes.time,
    name: 'time',
    label: 'Ώρα',
    customLabel: true,
    required: true
  },
  {
    control: FieldControllerTypes.autoselect,
    name: 'category',
    label: 'Κατηγορία Επικοινωνίας',
    customLabel: true,
    required: true,
    options: CommunicationTypes,
  }],
  [{
    control: FieldControllerTypes.textarea,
    name: 'record',
    label: 'Καταγραφή',
    type: 'search',
    required: true
  }]
];

export const batchEmailsColumns = (emailCategories: any[]) => [
  [{
    control: FieldControllerTypes.input,
    name: 'recipients',
    label: 'Παραλήπτες',
    disabled: true,
    required: true
  }],
  [{
    control: FieldControllerTypes.autoselect,
    name: 'category_id',
    label: 'Κατηγορία Καμπάνιας',
    options: emailCategories,
    customLabel: true,
    required: true
  }],
  [{
    control: FieldControllerTypes.input,
    name: 'subject',
    label: 'Θέμα',
    type: 'search',
    required: true
  }],
  [{
    control: FieldControllerTypes.textarea,
    name: 'description',
    label: 'Περιγραφή',
    type: 'search',
    required: true
  }]
];

